import { render, staticRenderFns } from "./GenreFeaturePopup.vue?vue&type=template&id=b3475616&scoped=true&"
import script from "./GenreFeaturePopup.vue?vue&type=script&lang=ts&"
export * from "./GenreFeaturePopup.vue?vue&type=script&lang=ts&"
import style0 from "./GenreFeaturePopup.vue?vue&type=style&index=0&id=b3475616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3475616",
  null
  
)

export default component.exports